import { render, staticRenderFns } from "./STable.vue?vue&type=template&id=ba653808&scoped=true&"
import script from "./STable.vue?vue&type=script&lang=js&"
export * from "./STable.vue?vue&type=script&lang=js&"
import style0 from "./STable.vue?vue&type=style&index=0&id=ba653808&prod&lang=scss&scoped=true&"
import style1 from "./STable.vue?vue&type=style&index=1&id=ba653808&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba653808",
  null
  
)

export default component.exports